import React from 'react'
import "./Foot.css"

const Foot = () => {
  return (
    <div className='foot'>
        <div className='foot1'>
            <h1>imposter</h1>
            <p>let the game begin with our sus community</p>
        </div>
        <div className='foot1'>
            <h3>NFT</h3>
            <h3>DOCs</h3>
            <h3>FAQ</h3>
        </div>
        <div className='foot1'>
            <h3>platform terms</h3>
            <h3>game terms</h3>
            <h3>nft terms</h3>
            <h3>privacy</h3>
        </div>
        <div className='foot1'>
            <h3>follows</h3>
                <i class="fa-brands fa-instagram"></i>
                <i class="fa-brands fa-linkedin-in"></i>
                <i class="fa-brands fa-facebook-f"></i>
                <i class="fa-brands fa-twitter"></i>
        </div>
    </div>
  )
}

export default Foot